/* APP */
import 'popper.js';
import 'bootstrap';
import '@fortawesome/fontawesome-pro/js/all';
import { WOW } from 'wowjs';
/* WADCMS
A décommenter si vous utilisez WadCms */
/* import '../../vendor/wad-commons/wad-cms/assets/js/app-cms'; */

/* WADGALLERY
A décommenter si vous utilisez WadGallery */
/* import '../../vendor/wad-commons/wad-gallery/assets/js/app-gallery'; */

/* GMAP
A décommenter si vous utilisez une Google Map */
/* import { Gmap } from './map'; */

$(document).ready(function(){

    new WOW().init();
    
    $('.navbar-index').on('click', '.anchor', function(event){
    	 event.preventDefault();
         let idArray = $.attr(this, 'href').split('#');
         if (idArray.length >= 2){
             let id = idArray[1];
             $('html, body').animate({
                 scrollTop: $('#'+id).offset().top
             }, 500);
         }
	});
});